import { getFestival } from "api/festival/festival";

export const queryFestival = ({ slug, user }) => ({
	queryKey: ["festival", slug, user?.uid],
	queryFn: async () => getFestival({ authToken: user?.accessToken, slug }),
});
